import React from "react";
import { ArrowLeft, LogOut } from "lucide-react";

const appInstallee = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

/* « ← Retour au site » : ouverte depuis le site (« Mon espace » du menu), l'application
   n'avait aucun chemin pour y revenir (retour de l'école, 09.10.2026). Un vrai chargement
   de page, comme le bouton inverse (RetourApp). Rien dans l'application installée sur le
   téléphone : là, le site s'ouvre depuis le navigateur. */
export const RetourSite = ({ className = "" }) => (appInstallee() ? null : (
  <a href="/" data-testid="espace-retour-site"
    className={`inline-flex items-center gap-1.5 text-[12px] font-semibold ${className}`}
    style={{ color: "var(--primary)" }}>
    <ArrowLeft size={13} /> Retour au site
  </a>
));

const initiales = (texte, secours) => {
  const mots = String(texte || "").trim().split(/\s+/).filter(Boolean);
  if (!mots.length) return String(secours || "?").slice(0, 1).toUpperCase();
  return (mots[0][0] + (mots[1]?.[0] || "")).toUpperCase();
};

/* L'en-tête de l'application : il reste en haut, en verre dépoli, et descend sous
   l'encoche de l'iPhone (safe-area). Il ne contient que ce qui sert partout — qui est
   connecté, quelle saison, et la sortie. */
export const EnTete = ({ titre, sousTitre, responsable, email, onQuitter, extra }) => (
  <header className="sticky top-0 z-30 border-b"
    style={{
      background: "rgba(255,255,255,0.86)",
      backdropFilter: "blur(16px)",
      WebkitBackdropFilter: "blur(16px)",
      borderColor: "var(--border)",
      paddingTop: "env(safe-area-inset-top, 0px)",
    }}
    data-testid="espace-header">
    {!appInstallee() && (
      <div className="max-w-lg mx-auto px-5 pt-2 -mb-1">
        <RetourSite />
      </div>
    )}
    <div className="max-w-lg mx-auto px-5 py-3 flex items-center gap-3">
      <div className="w-9 h-9 rounded-full grid place-items-center shrink-0 text-[11px] font-semibold"
        style={{ background: "var(--primary)", color: "#fff" }}
        data-testid="espace-header-avatar">
        {initiales(responsable, email)}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold leading-tight truncate">{titre}</div>
        {sousTitre && (
          <div className="text-[11px] text-[var(--muted)] leading-tight truncate">{sousTitre}</div>
        )}
      </div>
      {extra}
      <button onClick={onQuitter} aria-label="Quitter mon espace"
        className="w-10 h-10 grid place-items-center rounded-full shrink-0"
        style={{ background: "var(--primary-tint)", color: "var(--muted)" }}
        data-testid="espace-deconnexion-btn">
        <LogOut size={16} />
      </button>
    </div>
  </header>
);
